import React from "react"
import styled from "styled-components"
import Button from "../Button"
import { colors, fontSize, fontWeight, responsive } from "buoy-theme"
import { Paragraph } from "buoy-core"
import { generatePageUrl } from "../../common/utils"

const CardContainer = styled.div`
  position: relative;
  background: ${props => props.backgroundColor || colors.white(props)};
  box-shadow: ${props => props.boxShadow || "0 0 8px 0 rgba(0,0,0,0.08)"};
  border-top: ${props =>
    props.borderTop ||
    `2px solid ${props.theme.colors[props.color] || colors.black(props)}`};
  height: 100%;
  width: 100%;
  margin: 0 auto;
  ${responsive("max-width", "690px", "690px", "690px", "390px")}
  ${props =>
    props.padding
      ? `padding: ${props.padding};`
      : responsive(
          "padding",
          "24px 88px 44px 88px",
          "24px 88px 44px 88px",
          "24px 88px 44px 88px",
          "16px 16px 36px 16px"
        )}
`

const CardTitle = styled.h3`
  font-size: 26px;
  line-height: 1.3;
  color: ${props => props.theme.colors[props.color]};
  margin: 0 0 4px 0;
  font-weight: ${fontWeight.regular};
  text-align: center;
`

const CardSubtitle = styled.h5`
  color: ${props => props.theme.colors[props.color]};
  ${fontSize("bodyMain")};
  font-weight: ${fontWeight.regular};
  margin: 0;
`

const CardCopy = styled(Paragraph).attrs({ small: true })`
  margin: 16px 0;
`

const CardImage = styled.img`
  width: 55px;
  height: 65px;
  margin: 0 auto;
  display: block;
  ${props =>
    !props.productPage && `margin-bottom: 10px;`
  }
`


const CardTitleWrapper = styled.div`
  text-align: center;
`

const CardContent = styled.div`
  text-align: center;
`

const ChildrenWrapper = styled.div`
  padding-top: 0px;
`

const Card = ({
  title,
  subtitle,
  copy,
  color,
  image,
  buttonText,
  url,
  backgroundColor,
  boxShadow,
  borderTop,
  padding,
  children,
  productPage,
}) => (
  <CardContainer
    color={color}
    backgroundColor={backgroundColor}
    boxShadow={boxShadow}
    borderTop={borderTop}
    padding={padding}
  >
    {image && (
      <CardImage productPage={productPage} src={image.src} alt={image.alt} />
    )}
    <CardTitleWrapper productPage={productPage}>
      <CardTitle color={color}>{title}</CardTitle>
      <CardSubtitle color={color}>{subtitle}</CardSubtitle>
    </CardTitleWrapper>
    <CardContent>
      {copy && <CardCopy>{copy}</CardCopy>}
      {buttonText && (
        <Button
          href={generatePageUrl(url)}
          color={color}
          display="inline-block"
          padding="10px 50px"
          ghost={true}
          margin="16px 0"
        >
          {buttonText}
        </Button>
      )}
      {children && <ChildrenWrapper>{children}</ChildrenWrapper>}
    </CardContent>
  </CardContainer>
)

export { Card as default }



// WEBPACK FOOTER //
// ./src/components/Card/index.js